import {
  INIT_NVQUAL,
  NVQUAL_UPLOAD_DIALOG,
  FETCH_NVQUAL_REPORT,
  UPDATE_NVQUAL_REPORT_REVISION,
  UPDATE_NVQUAL_REVISION_NUMBER,
  UPDATE_NVQUAL_STATUS_SOURCE,
  POST_NVQUAL_STATUS,
  UPDATE_COMMENT,
  FETCH_NVQUAL_REPORT_INITIAL,
  UPDATE_CURRENT_REVISION,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  CHANGE_CURRENT_REVISION,
  DOWNLOAD_FILES,
  CREATE_NVBUGS,
  TOGGLE_CARD_COLLAPSE,
  EXPAND_CARD,
  UPDATE_PROJECT_NVQUAL_STATUS
} from './constants'

const initNvqual = () => ({ type: INIT_NVQUAL })

const fetchStart = () => ({ type: FETCH_START })
const fetchSuccess = () => ({ type: FETCH_SUCCESS })
const fetchError = (error) => ({ type: FETCH_ERROR, error })

const toggleNvqualUploadDialog = () => ({ type: NVQUAL_UPLOAD_DIALOG })

const downloadFiles = (fileIds, name, isFileName = false) => ({ type: DOWNLOAD_FILES, fileIds, name, isFileName })

const fetchNvqualReportInitial = () => ({ type: FETCH_NVQUAL_REPORT_INITIAL })
const fetchNvqualReport = () => ({ type: FETCH_NVQUAL_REPORT })
const updateNvqualRevisions = (revHeaders) => ({type: UPDATE_NVQUAL_REPORT_REVISION, revHeaders})
const updateNvqualRevisionNumber = (num) => ({type: UPDATE_NVQUAL_REVISION_NUMBER, num})
const updateNvqualStatusSource = (source) => ({type: UPDATE_NVQUAL_STATUS_SOURCE, source})
const onSaveNvqualCurStatus = () => ({type: POST_NVQUAL_STATUS})
const updateCurrentRevision = (rev) => ({type: UPDATE_CURRENT_REVISION, rev})
const updateNvqualCurComment = (text) => ({type: UPDATE_COMMENT, text})
const changeCurrentRevision = (revNum, revId) => ({type: CHANGE_CURRENT_REVISION, revNum, revId})

const createNvbugs = (revisionId, fetchAfter = false) => ({type: CREATE_NVBUGS, revisionId, fetchAfter})

const toggleCardCollapse = () => ({type: TOGGLE_CARD_COLLAPSE })
const expandCard = () => ({type: EXPAND_CARD })

const updateProjectNvqualStatus = (isClosed) => ({type: UPDATE_PROJECT_NVQUAL_STATUS, isClosed})

export {
  initNvqual,
  toggleNvqualUploadDialog,
  fetchNvqualReport,
  updateNvqualRevisions,
  updateNvqualRevisionNumber,
  updateNvqualStatusSource,
  onSaveNvqualCurStatus,
  updateNvqualCurComment,
  fetchNvqualReportInitial,
  updateCurrentRevision,
  fetchStart,
  fetchSuccess,
  fetchError,
  changeCurrentRevision,
  downloadFiles,
  createNvbugs,
  toggleCardCollapse,
  expandCard,
  updateProjectNvqualStatus
}
